module.exports = __webpack_public_path__ + "img/close.953aba89.svg";